import { TableHeadersType } from "../tableHeadersType";

export const USERS_HEADERS: TableHeadersType[] = [
  {
    label: "NAME",
    value: "name",
  },
  {
    label: "EMAIL",
    value: "email",
  },
  // {
  //   "label": "MOBILE",
  //   "value": "mobile"
  // },
  {
    label: "JOB TITLE",
    value: "job_title",
  },
  {
    label: "USER GROUP",
    value: "user_group",
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "updated_by",
  },
  {
    label: "EMPLOYMENT STATUS",
    value: "employment_status",
  },
  {
    label: "JOINING DATE",
    value: "joining_date",
  },
  {
    label: "STATUS",
    value: "status",
  },
];

export const CLIENT_HEADERS: TableHeadersType[] = [
  {
    label: "Client Code",
    value: "client_code",
  },
  {
    label: "Company Name",
    value: "company_name",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Name",
    value: "first_name",
  },
];

export const TEAM_DIRECTORY_HEADERS: TableHeadersType[] = [
  {
    label: "NAME",
    value: "name",
  },
  {
    label: "EMAIL",
    value: "email",
  },
  {
    label: "JOB TITLE",
    value: "job_title",
  },
  {
    label: "SKILLS",
    value: "skills",
  },
  {
    label: "USER BRANCH",
    value: "branch_name",
  },
  {
    label: "JOINING DATE",
    value: "joining_date",
  },
 
];